/**
 * for labels
 */
export const SELECT_LABEL = "SELECT_LABEL";
export const UPDATE_LABELS = "UPDATE_LABELS";

/**
 * for paint items
 */
export const ADD_ITEM = "ADD_ITEM";
export const UPDATE_ITEMS = "UPDATE_ITEMS";
export const REMOVE_ITEMS = "REMOVE_ITEMS";
export const SELECT_ITEMS = "SELECT_ITEMS";
export const REMOVE_ALL_ITEMS = "REMOVE_ALL_ITEMS";
export const MOVE_ITEM = "MOVE_ITEM";
export const SAVE_ALL_ITEMS = "SAVE_ALL_ITEMS";

//fetch items from backed and set
export const SET_ITEMS = "SET_ITEMS";


/**
* for platform
*/
export const SET_PLATFORM = 'SET_PLATFORM';

/**
 * for channel
 */
export const SET_CHANNEL = 'SET_CHANNEL';

/**
 * for region
 */
export const SET_REGION = 'SET_REGION';

/**
*	for region list
*/
export const GET_REGION_LIST = 'GET_REGION_LIST';

/**
 * for inputFocus
 */
export const SET_INPUT_FOCUS = 'SET_INPUT_FOCUS';

/**
 * for dimension
 */
export const SET_DIMENSION = 'SET_DIMENSION';



// WEBPACK FOOTER //
// ./src/redux/actions/actionTypes.js